import React from 'react';

import './styles.scss';

import {Popover} from "@material-ui/core";
import {Ripple} from "../../Buttons";
import copyTextToClipboard from "mn-utils/browser/copyTextToClipboard";
import CopyIcon from "../../../icons/Copy";

const getParentBgColor = (ref = {}) => {
  const node = ref.parentNode;

  if (!ref.parentNode) return false;
  if (node.tagName === 'BODY') return false;

  const tableClassesWithBgColor = ['odd', 'even'];
  const clsCheckFn = (cls) => node.classList.contains(cls);

  if (tableClassesWithBgColor.some(clsCheckFn)) {
    return window.getComputedStyle(node).getPropertyValue('background-color');
  }

  return getParentBgColor(ref.parentNode);
}

const CopyBtn = ({parentRef, title, value, handlePopoverClose}) => {
  const ref = React.useRef();

  const [copied, setCopiedState] = React.useState(false);
  const [style, setStyle] = React.useState({});

  const width = (ref.current || {}).offsetWidth;
  //
  // React.useEffect(() => {
  //   const parentBgColor = getParentBgColor((parentRef || {}).current);
  //   if (parentBgColor) setStyle({background: parentBgColor});
  // }, []);

  const onClick = () => {
    copyTextToClipboard(value || title);
    setCopiedState(true);
    setTimeout(() => {
      setCopiedState(false);
    }, 2000);
  }

  return (
    <div
      ref={ref}
      className="copy-popup__btn-wrapper"
      // onMouseLeave={handlePopoverClose}
      style={style}
    >
      <Ripple onClick={onClick}>
        <span className="copy-popup__content">
          {title}
        </span>
        <div className="copy-popup__icon">
          <CopyIcon />
        </div>
      </Ripple>
      {copied
        ? (
          <div className="copy-popup__result-text">
            <span className="copy-popup__content">
              {width > 250
                ? 'Text has been copied to clipboard'
                : width > 150
                  ? 'Copied to clipboard'
                  : width > 100
                    ? 'Copied'
                    : title
              }
            </span>
            <div className="copy-popup__icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 0C3.13425 0 0 3.13425 0 7C0 10.8658 3.13425 14 7 14C10.8658 14 14 10.8658 14 7C14 3.13425 10.8658 0 7 0ZM6.27083 10.087L3.64583 7.54133L4.72908 6.4575L6.27083 7.91933L9.56258 4.54533L10.6458 5.62858L6.27083 10.087Z" fill="#2CE889"/>
              </svg>
            </div>
          </div>
        ) : (
          <span />
          // <div className="copy-popup__helper-text">
          //   Click to copy
          // </div>
        )
      }
    </div>
  )
}

export default ({title, value, children, anchorOrigin = {}, transformOrigin = {}, style}) => {
  const [open, setOpenState] = React.useState(false);
  const ref = React.useRef();

  const handlePopoverOpen = () => {
    setOpenState(true);
  };

  const handlePopoverClose = () => {
    setOpenState(false);
  };

  return (
    <>
      <div
        ref={ref}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        className="tooltip-block"
        onMouseOver={handlePopoverOpen}
      >
        {children}
      </div>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        className="copy-popup"
        anchorEl={(ref || {}).current}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
          ...anchorOrigin
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
          ...transformOrigin
        }}
        BackdropProps={{
          onMouseOver: handlePopoverClose,
          invisible: true
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <CopyBtn
          title={title}
          value={value}
          parentRef={ref}
          handlePopoverClose={handlePopoverClose}
        />
      </Popover>
    </>
  );
}
